import React, { useContext, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import useAccess from "@hooks/useAccess";
import { ApplicationContext } from "@context/ApplicationContext";
import Loader from "@components/Ui/Loader";
import VersionedLayout from "@components/Wrappers/VersionedLayout";
import SubscriberGroupNotLaunchedPage from "@pages/SubscriberGroupNotLaunchedPage";

const SubscriberGroupLandingPage = () => {
    const { groupCode } = useParams();
    const { subscriberGroup, fetchSubscriberGroup, isLoading, whiteLabel } = useContext(ApplicationContext);
    const { isFullyLoggedIn, requiresFullLogin, canSignInOnSite } = useAccess();

    useEffect(() => {
        if (groupCode) {
            fetchSubscriberGroup(groupCode);
        }
    }, [groupCode, fetchSubscriberGroup]);

    const isDataReady = !isLoading && !!subscriberGroup?.id && !!whiteLabel && typeof whiteLabel.site_version !== "undefined";

    if (!isDataReady) {
        return <Loader />;
    }

    if (subscriberGroup?.is_launched === false) {
        return (
            <VersionedLayout>
                <SubscriberGroupNotLaunchedPage subscriberGroup={subscriberGroup} />
            </VersionedLayout>
        );
    }

    if (requiresFullLogin && !isFullyLoggedIn && canSignInOnSite) {
        return <Navigate to="/login" replace />;
    }

    return <Navigate to="/" replace />;
};

export default SubscriberGroupLandingPage;
